module.exports = __webpack_public_path__ + "static/media/icon-qrcode.97751a24.svg";